import { connect } from "dva";
import { createForm } from "rc-form";
import { RequestManagement } from "./RequestManagement";
import { routerRedux } from "dva/router";

const fetchActionMy = "application/fetchMyApplicationForms";
const fetchActionOpen = "application/fetchOpenApplicationForms";
const fetchActionClose = "application/fetchCloseApplicationForms";

export const mapStateToProps = (state, ownProps) => {
  const {
    authentication,
    application,
    config: { userAggerateRequest },
  } = state;
  const { accessList } = authentication;
  const {
    myApplicationFormsList,
    myApplicationFormsTotal,
    openApplicationFormsList,
    openApplicationFormsTotal,
    closedApplicationFormsList,
    closedApplicationFormsTotal,
  } = application;
  return {
    myApplicationFormsList,
    myApplicationFormsTotal,
    openApplicationFormsList,
    openApplicationFormsTotal,
    closedApplicationFormsList,
    closedApplicationFormsTotal,
    accessList,
    fetchActionOpen,
    fetchActionClose,
    fetchActionMy,
    userAggerateRequest,
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    redirect(pathname) {
      dispatch(routerRedux.push({ pathname: `${pathname}` }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(createForm()(RequestManagement));
